import { Component, Output, Input, EventEmitter, inject } from '@angular/core';
import { AdminService } from '../../admin.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-delete-products',
  templateUrl: './delete-products.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [
    MatSelectModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class DeleteProductsComponent {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  @Input() lifeProductTables;
  deleteLifeProducts = {
    table: null,
    column: null,
    status: null,
    statusClass: null,
  };
  deleteFile;
  deleteFileName;

  onFileSelected(event) {
    this.deleteFile = event.target.files[0];
    if (this.deleteFile) {
      this.deleteFileName = this.deleteFile.name;
    }
  }

  deleteLifeProduct() {
    this.toggleLoading.emit();
    this.deleteLifeProducts.status = null;
    this.deleteLifeProducts.statusClass = null;
    this.admnSrvc
      .deleteLifeProduct(
        this.deleteLifeProducts.table,
        this.deleteLifeProducts.column,
        this.deleteFile
      )
      .subscribe({
        next: res => {
          if (res) {
            if (res.name && res.name === 'HttpErrorResponse') {
              this.toggleLoading.emit();
              this.deleteLifeProducts.status = `${res.status} - ${res.statusText} - ${res.message}`;
              this.deleteLifeProducts.statusClass = 'failure';
              return throwError(() => res.error || 'Server error');
            } else {
              this.toggleLoading.emit();
              this.deleteLifeProducts.status = res;
              this.deleteLifeProducts.statusClass = 'success';
            }
          }
        },
        error: catchError(err => {
          this.toggleLoading.emit();
          this.deleteLifeProducts.status = err;
          this.deleteLifeProducts.statusClass = 'failure';
          return throwError(() => err.error || 'Server error');
        }),
      });
  }
}
